import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import React, { FC, ReactElement } from "react";

import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import Container from "@mui/material/Container";

import CodeSnippet from "@/components/CodeSnippet";

interface DisplayJwtProps {
  jwt: string;
  open: boolean;
  onClose: () => void;
  title: string | ReactElement;
  message: string;
}

export const DisplayJWT: FC<DisplayJwtProps> = ({
  jwt,
  open,
  onClose,
  title,
  message,
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          maxWidth: 500,
          width: "100%",
        },
      }}
    >
      <DialogTitle
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <Typography variant="inherit">{title}</Typography>
        <IconButton onClick={onClose} size="small">
          <SvgIcon fontSize="small">
            <XMarkIcon />
          </SvgIcon>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Container component={"div"} disableGutters>
          <Stack spacing={2} sx={{ mb: 2 }}>
            <Alert severity="success">{message}</Alert>
            <CodeSnippet code={jwt} copyInfo="copied_jwt" showViewToggle />
          </Stack>
        </Container>
      </DialogContent>
    </Dialog>
  );
};
